export default __webpack_public_path__ + "static/media/357.f327fe6e.gif";